module.exports = new __parcel__URL__("c1s2.0ea95ba8.png").toString();